import React, { Component } from 'react';
import { connect } from 'react-redux';
import { placeEnrollOrder } from '../modules/order_actions';
import EnrollmentBraintreeDropin  from './EnrollmentBraintreeDropin.jsx';

class EnrollPaymentInfo extends Component {

  constructor(props) {
    super(props);
    this.state = {
      lastModal : this.props.activeModal
    };
  }

  componentWillReceiveProps(nextProps){
    //refresh braintree obj, evertime shopping cart is opened
    if( this.refs && this.refs.enrollBraintreeObj && this.state.lastModal !== nextProps.activeModal ){
      if (this.state.lastModal === "cart" ) {
        this.refs.enrollBraintreeObj.getWrappedInstance().braintreeObjDestroy();
      } else if(  nextProps.activeModal === "cart" ) {
        this.refs.enrollBraintreeObj.getWrappedInstance().braintreeObjCreate(this.props.customer ? this.props.customer.braintree_token : null, this.props.tla)
      }
    }
    this.setState({ lastModal : nextProps.activeModal });
  }

  render() {
    let oCheckout = (
      <div>
        <p>Please Wait...</p>
      </div>
    );
    if (this.props.customer.braintree_token) {
      oCheckout = (
        <div className="info-edit-form showing" >
            <div className="full-width">
              <h4 className="alt">Payment Information</h4>
              <CustomBraintreeDropin ref='enrollBraintreeObj'
                submitFunction = {placeEnrollOrder}
                uniqueContainer = "enroll-payment-form"
                enrollInlineDisplay = {true} />
            </div>
            <div className="center">
              {/* @TODO Remove - Temp image for layout until it loads form symantic */}
              <img src={"/images/" + this.props.tla.toLowerCase() + "/vseal.gif"} width="100px" height="58px"/>
              <script type="text/javascript" src={"https://seal.websecurity.norton.com/getseal?host_name=" + this.props.url  + "&amp;size=S&amp;use_flash=NO&amp;use_transparent=YES&amp;lang=en"}></script>
            </div>
        </div>
      );
    }
    return oCheckout;
  }
};

function mapStateToProps(state){
    return {
      'tla': state.store.tla,
      'url': state.store.url,
      'activeModal': state.activeModal,
      'customer': state.customer
    };
}

export default connect(mapStateToProps)(EnrollPaymentInfo);


// WEBPACK FOOTER //
// ./src/components/EnrollPaymentInfo.jsx